import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { X, Cookie } from "lucide-react";

const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setShowBanner(false);
  };

  const refuseCookies = () => {
    localStorage.setItem("cookieConsent", "refused");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-in slide-in-from-bottom duration-500">
      <div className="container mx-auto max-w-6xl">
        <div className="bg-gradient-to-br from-primary via-primary to-secondary text-white rounded-2xl shadow-2xl border border-white/20 overflow-hidden">
          <div className="p-6 md:p-8">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
              <div className="flex-shrink-0">
                <div className="w-16 h-16 bg-accent/20 rounded-xl flex items-center justify-center">
                  <Cookie className="w-8 h-8 text-accent" />
                </div>
              </div>
              
              <div className="flex-1">
                <h3 className="text-xl font-bold mb-2">Gestion des cookies</h3>
                <p className="text-white/90 text-sm leading-relaxed">
                  Nous utilisons des cookies pour améliorer votre expérience sur notre site, 
                  analyser le trafic et personnaliser le contenu. En cliquant sur "Accepter", 
                  vous consentez à l'utilisation de tous les cookies. Pour plus d'informations, 
                  consultez notre <a href="/mentions-legales" className="underline hover:text-accent transition-colors">politique de cookies</a>.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
                <Button
                  onClick={refuseCookies}
                  variant="outline"
                  className="bg-white/10 border-white/30 text-white hover:bg-white/20 hover:text-white transition-smooth"
                >
                  Refuser
                </Button>
                <Button
                  onClick={acceptCookies}
                  className="bg-accent hover:bg-accent/90 text-white shadow-glow transition-smooth"
                >
                  Accepter
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
